// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_OIJOU","fullScreen":"index_fullScreen_Xqb7i"};